import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getRequest } from "services/api";
// import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { buildQueryString } from "utils/queryHelpers";

const AgentPenaltyContext = createContext();

export const AgentPenaltyProvider = ({ children }) => {
  const [agentPenalties, setAgentPenalties] = useState({
    data: [],
    pagination: null,
    error: null,
    loading: false,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
  });

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    // limit: LIMIT_DATA_PER_PAGE,
    // tambahkan include jika diperlukan
    include: "agent,season",
  });

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      console.log("search", e.target.value);
      setFilterOptions((prevState) => ({
        ...prevState,
        search: e.target.value,
      }));
    }
  };

  const fetchAgentPenalties = useCallback(async () => {
    setAgentPenalties((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const response = await getRequest(`/agent-penalty${queryString}`);
      if (response.success) {
        setAgentPenalties({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });

        setFilterOptions((prev) => ({
          ...prev,
          totalPages: response.pagination.last_page,
        }));
      }
    } catch (error) {
      setAgentPenalties({
        data: [],
        pagination: null,
        error: error.message,
        loading: false,
      });
    }
  }, [queryString]);

  useEffect(() => {
    fetchAgentPenalties();
  }, [fetchAgentPenalties]);

  const handlePageChange = (page) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      currentPage: page,
    }));
  };

  const totalPages = agentPenalties.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages: totalPages,
    currentPage: filterOptions.currentPage,
    onPageChange: handlePageChange,
    visiblePages: 5,
  });

  return (
    <AgentPenaltyContext.Provider
      value={{
        agentPenalties,
        filterOptions,
        handleSearch,
        refetch: fetchAgentPenalties,
        Pagination,
      }}
    >
      {children}
    </AgentPenaltyContext.Provider>
  );
};

export const useAgentPenalty = () => {
  const context = useContext(AgentPenaltyContext);
  if (!context) {
    throw new Error("useAgentPenalty must be used within AgentPenaltyProvider");
  }

  const fetchOptions = async (inputValue) => {
    const response = await getRequest(`/agent-penalty?search=${inputValue}`);
    if (response.success) {
      return response.data.map((penalty) => ({
        value: penalty.id,
        label: `${penalty.agent?.name || "Unknown Agent"} - ${penalty.reason}`,
      }));
    }
    return [];
  };

  return { ...context, fetchOptions };
};
